import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListPembayaranAirAset } from "@/services/getData"

export default function MasterPembayaranAirAsetPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listPembayaranAirAset"],
    queryFn: getListPembayaranAirAset,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
